import { AFFILIATE_TRACKING_PARAMS } from '../constants';
import type { TrackingParams } from '../types';

/** `stag`/`ref_code` survive sign out: a registered browser never gets them re-sent (DEV-1636). */
export const getAffiliateParams = (params: TrackingParams) => {
  const affiliateParams: TrackingParams = {};

  AFFILIATE_TRACKING_PARAMS.forEach((param) => {
    if (params[param]) {
      affiliateParams[param] = params[param];
    }
  });

  return affiliateParams;
};
